(function() {
  'use strict';
  function initProductSlider() {
    const productSliders = document.querySelectorAll('.bggle_product-slider');

    if (productSliders.length === 0) return;

    productSliders.forEach(function(productSlider) {
      productSlider.classList.add('slim-scrollbar');
      productSlider.style.overflowX = 'auto';

    });
  }

  function waitForElement() {
    initProductSlider();
    setTimeout(initProductSlider, 500);
    setTimeout(initProductSlider, 1000);

    const observer = new MutationObserver(function(mutations) {
      const hasNewNodes = mutations.some(function(mutation) {
        return mutation.addedNodes.length > 0;
      });

      if (hasNewNodes) {
        initProductSlider();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForElement);
  } else {
    waitForElement();
  }

})();
